import {IState} from './model'

export interface IPersistState {
  token?: string
}

export const persistState = (state: IState): IPersistState => ({
  token: state.token,
})

export const hydrateState = (state: IPersistState): IState => {
  const token = state && state.token
  return {
    token: state.token,
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/login/persist.ts